export const CREATE_ORDER_TIMEOUT_MS = 30000

export function isMutationTimeoutError(err) {
  const name = err?.name || ''
  const message = String(err?.message || err?.error || '')
  return (
    name === 'TimeoutError' ||
    name === 'AbortError' ||
    message === 'CREATE_ORDER_TIMEOUT' ||
    /aborted|abort/i.test(message)
  )
}

/**
 * RTK mutation triggers resolve with `{data|error}` and do not reject.
 * Always unwrap, abort if the request hangs, and swallow the late unwrap
 * rejection after a timeout so it does not become an unhandled promise.
 */
export async function unwrapMutationWithTimeout(
  trigger,
  arg,
  timeoutMs = CREATE_ORDER_TIMEOUT_MS,
) {
  const request = trigger(arg)
  const unwrapPromise =
    typeof request?.unwrap === 'function'
      ? request.unwrap()
      : Promise.resolve(request)

  let timedOut = false
  let timerId
  const timeoutPromise = new Promise((_, reject) => {
    timerId = setTimeout(() => {
      timedOut = true
      if (typeof request?.abort === 'function') {
        request.abort()
      }
      const err = new Error('CREATE_ORDER_TIMEOUT')
      err.name = 'TimeoutError'
      reject(err)
    }, timeoutMs)
  })

  try {
    return await Promise.race([unwrapPromise, timeoutPromise])
  } catch (err) {
    if (timedOut) {
      const timeoutErr = new Error('CREATE_ORDER_TIMEOUT')
      timeoutErr.name = 'TimeoutError'
      timeoutErr.cause = err
      throw timeoutErr
    }
    throw err
  } finally {
    clearTimeout(timerId)
    unwrapPromise.catch(() => {})
    timeoutPromise.catch(() => {})
  }
}
